module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-form"
  }, [_c('error-reveal', {
    attrs: {
      "error": _vm.uierror
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.queryEnabled && _vm.refreshEnabled),
      expression: "!queryEnabled && refreshEnabled"
    }],
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-6 columns"
  }, [_c('label', [_vm._v("Utolsó beolvasás:")]), _vm._v(" "), _c('div', {
    staticClass: "displayfield"
  }, [_vm._v(_vm._s(_vm.analyticsReadingInf))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.queryEnabled && _vm.refreshEnabled),
      expression: "!queryEnabled && refreshEnabled"
    }],
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-4 columns end"
  }, [_c('button', {
    staticClass: "button primary trans-uppercase",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.refresh
    }
  }, [_vm._v("Frissítés")])])]), _vm._v(" "), _c('joi-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.queryEnabled),
      expression: "queryEnabled"
    }],
    attrs: {
      "data": _vm.data,
      "schema": _vm.validationSchema,
      "error": _vm.formError
    },
    on: {
      "formdataready": _vm.save
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 medium-6 columns small-centered"
  }, [_c('span', {
    attrs: {
      "data-form-error-callout": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-8 medium-6 columns"
  }, [_c('label', [_vm._v("Utolsó beolvasás:")]), _vm._v(" "), _c('div', {
    staticClass: "displayfield"
  }, [_vm._v(_vm._s(_vm.analyticsReadingInf))])]), _vm._v(" "), _c('div', {
    staticClass: "small-4 medium-6 columns text-right"
  }, [_c('button', {
    staticClass: "button primary trans-uppercase",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.refresh
    }
  }, [_vm._v("Frissítés")])])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-6 columns"
  }, [_c('label', {
    attrs: {
      "error-path": "channels"
    }
  }, [_vm._v("\n          Oldalak:\n        ")]), _vm._v(" "), _c('channel-cards', {
    attrs: {
      "channels": _vm.availableChannels
    },
    model: {
      value: (_vm.data.channels),
      callback: function($$v) {
        _vm.$set(_vm.data, "channels", $$v)
      },
      expression: "data.channels"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 columns"
  }, [_c('label', [_vm._v("\n          Poszt típusok:\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.types),
      expression: "data.types"
    }],
    attrs: {
      "id": "post-type-status",
      "type": "checkbox",
      "value": "status"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.types) ? _vm._i(_vm.data.types, "status") > -1 : (_vm.data.types)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.types,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "status",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "types", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "types", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "types", $$c)
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": "post-type-status"
    }
  }, [_vm._v("Státusz")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.types),
      expression: "data.types"
    }],
    attrs: {
      "id": "post-type-link",
      "type": "checkbox",
      "value": "link"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.types) ? _vm._i(_vm.data.types, "link") > -1 : (_vm.data.types)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.types,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "link",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "types", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "types", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "types", $$c)
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": "post-type-link"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.types),
      expression: "data.types"
    }],
    attrs: {
      "id": "post-type-photo",
      "type": "checkbox",
      "value": "photo"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.types) ? _vm._i(_vm.data.types, "photo") > -1 : (_vm.data.types)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.types,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "photo",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "types", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "types", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "types", $$c)
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": "post-type-photo"
    }
  }, [_vm._v("Kép")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.types),
      expression: "data.types"
    }],
    attrs: {
      "id": "post-type-video",
      "type": "checkbox",
      "value": "video"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.types) ? _vm._i(_vm.data.types, "video") > -1 : (_vm.data.types)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.types,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "video",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "types", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "types", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "types", $$c)
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": "post-type-video"
    }
  }, [_vm._v("Videó")]), _vm._v(" "), _c('span', {
    attrs: {
      "error-path": "types"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-6 columns"
  }, [_c('label', [_vm._v("\n          Vizsgált időszak:\n          "), _c('date-picker', {
    attrs: {
      "mode": "range",
      "error-path": "interval"
    },
    model: {
      value: (_vm.data.interval),
      callback: function($$v) {
        _vm.$set(_vm.data, "interval", $$v)
      },
      expression: "data.interval"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "error-path": "interval.min"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "error-path": "interval.max"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-6 columns"
  }, [_c('label', [_vm._v("\n          A domain tartalmazza:\n          "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.host),
      expression: "data.host"
    }],
    domProps: {
      "value": (_vm.data.host)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "host", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-6 columns"
  }, [_c('label', [_vm._v("\n          Az URL tartalmazza:\n          "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.link),
      expression: "data.link"
    }],
    domProps: {
      "value": (_vm.data.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "link", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded bottom"
  }, [_c('div', {
    staticClass: "small-4 columns"
  }, [_c('button', {
    staticClass: "button primary trans-uppercase",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Lekérdezés")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-84b04b3a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/insights/Query.vue
// module id = 484
// module chunks = 2